import PropTypes from 'prop-types';
// material
import { ThemeProvider } from '@material-ui/core/styles';
import BrandedStyles from './brandedStyles';
// ----------------------------------------------------------------------

BrandedThemeConfig.propTypes = {
    children: PropTypes.node
};

export default function BrandedThemeConfig({ children }) {

    const theme = (parentTheme) => ({
        ...parentTheme,

    });

    return (
        <ThemeProvider theme={theme}>
            <BrandedStyles/>
            {children}
        </ThemeProvider>
    );
}
